export const radius = {
  r1: '8px',
  r2: '10px',
  r3: '24px',
  rMax: '9999px',
}
